import React, { useMemo, useState, useEffect } from 'react';
import { Box, Typography, Grid, TextField, Checkbox, FormControlLabel, Button, Alert, Paper } from '@mui/material';
import { useLocation } from 'react-router-dom';
import http from '../../services/http';

const useQuery=()=>new URLSearchParams(useLocation().search);

export default function GeriatricClinic(){
  const q=useQuery();
  const citizenId=q.get('citizenId')||''; const visitId=q.get('visitId')||'';
  const storageKey=useMemo(()=>`clinical:geriatric:${citizenId||'unspecified'}:${visitId||'none'}`,[citizenId,visitId]);

  const [form,setForm]=useState({mmse:'',adl:'',iadl:'',falls:'',polypharmacy:'',vision:'',hearing:'',nutrition:'',notes:'',includeInReport:true});
  const [msg,setMsg]=useState(''); const [err,setErr]=useState('');

  useEffect(()=>{try{const x=JSON.parse(localStorage.getItem(storageKey)||'null'); if(x) setForm(f=>({...f,...x}));}catch{}},[storageKey]);

  const save=async()=>{
    try{
      localStorage.setItem(storageKey,JSON.stringify(form));
      if(visitId){
        await http.post(`/api/visits/${encodeURIComponent(visitId)}/clinical/geriatric`,{data:form});
      }
      setMsg('Geriatric clinic form saved'); setErr('');
    }catch(e){ setErr(e.message||'Cannot save'); setMsg(''); }
  };

  return(
    <Box className="p-6">
      {err && <Alert severity="error" sx={{mb:2}}>{err}</Alert>}
      {msg && <Alert severity="success" sx={{mb:2}}>{msg}</Alert>}

      <Typography variant="h5" sx={{mb:2}}>Geriatric Clinic</Typography>
      <Paper variant="outlined" sx={{p:2}}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}><TextField label="MMSE (score)" value={form.mmse} onChange={(e)=>setForm(f=>({...f,mmse:e.target.value}))} fullWidth/></Grid>
          <Grid item xs={12} sm={6}><TextField label="ADL (Katz/Barthel)" value={form.adl} onChange={(e)=>setForm(f=>({...f,adl:e.target.value}))} fullWidth/></Grid>
          <Grid item xs={12} sm={6}><TextField label="IADL (Lawton)" value={form.iadl} onChange={(e)=>setForm(f=>({...f,iadl:e.target.value}))} fullWidth/></Grid>
          <Grid item xs={12} sm={6}><TextField label="Falls (last 1 year)" value={form.falls} onChange={(e)=>setForm(f=>({...f,falls:e.target.value}))} fullWidth/></Grid>
          <Grid item xs={12} sm={6}><TextField label="Polypharmacy (list meds)" value={form.polypharmacy} onChange={(e)=>setForm(f=>({...f,polypharmacy:e.target.value}))} fullWidth multiline/></Grid>
          <Grid item xs={12} sm={6}><TextField label="Nutrition (MNA/notes)" value={form.nutrition} onChange={(e)=>setForm(f=>({...f,nutrition:e.target.value}))} fullWidth/></Grid>
          <Grid item xs={12} sm={6}><TextField label="Vision screen" value={form.vision} onChange={(e)=>setForm(f=>({...f,vision:e.target.value}))} fullWidth/></Grid>
          <Grid item xs={12} sm={6}><TextField label="Hearing screen" value={form.hearing} onChange={(e)=>setForm(f=>({...f,hearing:e.target.value}))} fullWidth/></Grid>
          <Grid item xs={12}><TextField label="Notes" value={form.notes} onChange={(e)=>setForm(f=>({...f,notes:e.target.value}))} fullWidth multiline minRows={3}/></Grid>
          <Grid item xs={12}><FormControlLabel control={<Checkbox checked={!!form.includeInReport} onChange={(e)=>setForm(f=>({...f,includeInReport:e.target.checked}))}/>} label="Include in Clinical Services Report"/></Grid>
          <Grid item xs={12}><Button variant="contained" onClick={save}>Save</Button></Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
